import { Check } from "lucide-react";
import { formatMoney } from "@/lib/money";
import { ReceiptDownloadLink } from "./ReceiptDownloadLink";
import { ReceiptImagePreview } from "./ReceiptImagePreview";

interface ReceiptDisplayProps {
  receiptTotalCents: number;
  receiptUrl?: string;
  compact?: boolean;
}

export function ReceiptDisplay({
  receiptTotalCents,
  receiptUrl,
  compact = false,
}: ReceiptDisplayProps) {
  const amount = formatMoney(receiptTotalCents);

  if (!receiptUrl) {
    return (
      <span className="inline-flex items-center gap-1.5 text-sm font-semibold tabular-nums text-surface-900">
        <Check className="h-4 w-4 shrink-0 text-success-600" />
        {amount}
      </span>
    );
  }

  return (
    <div className="flex items-center gap-2.5">
      <ReceiptImagePreview fileUrl={receiptUrl} compact={compact} />
      <span className="min-w-0 flex-1 text-sm font-semibold tabular-nums text-surface-900">
        {amount}
      </span>
      <ReceiptDownloadLink fileUrl={receiptUrl} />
    </div>
  );
}
